/// <amd-module name="Repos/Discussion/Editor/Widgets/AddBaseWidget" />
import * as ReactDOM from "react-dom";

export abstract class AddBaseWidget<TWidgetProps> {
    protected disposables: monaco.IDisposable[] = [];
    protected domNode: HTMLElement;
    protected editor: monaco.editor.ICodeEditor;
    protected originalSelection: monaco.Selection | undefined;
    protected props: TWidgetProps;
    protected selection: monaco.Selection | undefined;

    constructor(editor: monaco.editor.ICodeEditor, props: TWidgetProps) {
        this.editor = editor;
        this.props = props;

        this.disposables.push(
            this.editor.onDidChangeCursorSelection(e => {
                this.setSelection(undefined, e.selection);

                const selectionIsEmpty =
                    !e.selection || (e.selection.endLineNumber === e.selection.startLineNumber && e.selection.endColumn === e.selection.startColumn);
                if (!selectionIsEmpty) {
                    this.setSelection(e.selection, e.selection);
                }
            })
        );
    }

    public dispose(): void {
        ReactDOM.unmountComponentAtNode(this.domNode);
        this.disposables.forEach(d => d.dispose());
        this.disposables = [];

        // @ts-ignore TypeScript 4.0 upgrade
        delete this.editor;
        // @ts-ignore TypeScript 4.0 upgrade
        delete this.props;
    }

    protected setSelection(selection: monaco.Selection | undefined, originalSelection: monaco.Selection | undefined) {
        this.selection = selection;
        this.originalSelection = originalSelection;
    }
}
